import { useCallback, ReactNode } from "react"
import { Flex } from "@shared/primitive-components"
import { ResolvedFleetEntry } from "../../api/fleet"
import { useInternalFlags } from "../../hooks"
import { ConfirmFleetEntryChangesContent } from "./components"
import { ActionButtons } from "../../components/ActionButtons"

export const EDIT_CONFIRMATION_BUTTON_DATA_TEST_IDS = {
  back: `editConfirmationBack`,
  cancel: `editConfirmationCancel`,
  next: `editConfirmationNext`,
}

export type ConfirmFleetEntryChangesProps = {
  changedEntries: ReadonlyArray<ResolvedFleetEntry>
  unchangedEntries: ReadonlyArray<ResolvedFleetEntry>
  displayAddedInErrorWarning?: boolean
  isInsideModal?: boolean
  dataTestId?: string
  onConfirmed?: () => void
  onBack?: () => void
  onCancel?: () => void
}

export const ConfirmFleetEntryChanges = ({
  changedEntries,
  unchangedEntries,
  displayAddedInErrorWarning,
  isInsideModal,
  dataTestId,
  onConfirmed,
  onBack,
  onCancel,
}: ConfirmFleetEntryChangesProps) => {
  const { flags } = useInternalFlags()

  const Wrapper = useCallback(
    // eslint-disable-next-line react/no-unused-prop-types
    ({ children }: { children: ReactNode }) =>
      isInsideModal ? (
        <div data-testid={dataTestId}>{children}</div>
      ) : (
        <Flex width="100%" flexDirection="column" data-testid={dataTestId}>
          {children}
          <ActionButtons
            onCancel={onCancel}
            onBack={onBack}
            onNext={onConfirmed}
            nextDisabled={!changedEntries.length || flags.isDemoModeEnabled}
            nextText="Apply changes"
            dataTestIds={EDIT_CONFIRMATION_BUTTON_DATA_TEST_IDS}
          />
        </Flex>
      ),
    [isInsideModal, changedEntries.length, dataTestId, onConfirmed, onCancel, onBack, flags.isDemoModeEnabled]
  )

  return (
    <Wrapper>
      <ConfirmFleetEntryChangesContent {...{ changedEntries, unchangedEntries, displayAddedInErrorWarning }} />
    </Wrapper>
  )
}

ConfirmFleetEntryChanges.defaultProps = {
  displayAddedInErrorWarning: false,
  isInsideModal: false,
  dataTestId: undefined,
  onConfirmed: undefined,
  onBack: undefined,
  onCancel: undefined,
}
